module.exports = __webpack_public_path__ + "assets/img/work-in-progress.6bdc26b3.png";